import React, { useState } from 'react';
import Footer from './Footer';
import "./cardMiddle.scss";
import { withRouter } from 'react-router-dom'
import { useMediaQuery } from '@material-ui/core'
import {
    isBrowser,
    isMobile,
  } from 'react-device-detect';


const CardMiddle = (props) => {
    const { mainTitle, desFooter, footerTitle, linkTo, history, noCloseIcon } = props
    
    const [step, setStep] = useState(0)

    const goHome = () => {
        history.push('/')
    }

    return (
        <>
            <div className="cardMiddle">
                <div className="cardMiddle_header">
                    <figure className="cardMiddle_close">
                        
                        {isMobile && !noCloseIcon ? (
                            <img
                                src="/img/icons/close.svg"
                                alt="close"
                                onClick={goHome}
                            />
                        ) : ''}
                    </figure>

                    <figure className="cardMiddle_logo">
                        <img src="/img/Logo-box.svg" alt="logo" />
                    </figure>

                    <p className="cardMiddle_title">{mainTitle} </p>
                </div>

                <div className="cardMiddle_body">
                    <div className="cardMiddle_buttons">

                        {props.children}
                    </div>
                </div>
                <div className="cardMiddle_footer">
                    <Footer
                        margin="40px 0px 40px"
                        text={desFooter}
                        textLink={footerTitle}
                        linkTo={linkTo}
                    />
                </div>
            </div>
        </>
    );
}

export default withRouter(CardMiddle);
